// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Menu } from "semantic-ui-react";
import "./ApplicationHeader.less";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("header");
export const ApplicationHeader = props => {
  const {
    children
  } = props;
  return React.useMemo(() => /*#__PURE__*/_jsx(Menu, {
    className: getClassName(className),
    attached: "top",
    size: "small",
    borderless: true,
    compact: true,
    fluid: true,
    secondary: true,
    children: children
  }), [children]);
};